import React from "react";
import DashboardTopSearch from "../../../components/DashboardTopSearch/DashboardTopSearch";
import { useDispatch } from "react-redux";
import { getDeactivatedUsersAPI } from "../../../redux/features/adminSlice";
import DeactivatedUserTable from "../../../components/DeactivatedUserTable/DeactivatedUserTable";
import AdminNotification from "../../../components/Notification/AdminNotification";

const DeactivatedUsers = () => {
  const dispatch = useDispatch();

  const fetchDeactivatedUsers = async (token) => {
    return await dispatch(getDeactivatedUsersAPI({ token })).unwrap();
  };

  return (
    <>
      <div className="topbar mb-20 mb-lg-36">
        <div className="d-flex align-items-center justify-content-between">
          <h3 className="ad-heading-04 fw-bold mb-8">Deactivated Users</h3>
          <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
            <DashboardTopSearch />
            <AdminNotification />
          </div>
        </div>
      </div>
      <div className="card-default-style px-14 py-40">
        <DeactivatedUserTable fetchApi={fetchDeactivatedUsers} />
      </div>
    </>
  );
};

export default DeactivatedUsers;